"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventbriteBulkImportResultDto = exports.EventbriteOrganizationEventDto = exports.EventbriteVenueAddResultDto = exports.EventbriteVenueSuggestionDto = exports.EventbriteLinkedIvyEventDto = void 0;
const swagger_1 = require("@nestjs/swagger");
/** An Ivy event already linked to an Eventbrite event. */
class EventbriteLinkedIvyEventDto {}
exports.EventbriteLinkedIvyEventDto = EventbriteLinkedIvyEventDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], EventbriteLinkedIvyEventDto.prototype, "venuePublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], EventbriteLinkedIvyEventDto.prototype, "venueName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], EventbriteLinkedIvyEventDto.prototype, "specialPublicId", void 0);
/** An Ivy venue near an Eventbrite event's venue, as an import target. */
class EventbriteVenueSuggestionDto {}
exports.EventbriteVenueSuggestionDto = EventbriteVenueSuggestionDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], EventbriteVenueSuggestionDto.prototype, "venuePublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], EventbriteVenueSuggestionDto.prototype, "venueName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], EventbriteVenueSuggestionDto.prototype, "address", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Distance from the Eventbrite venue, in meters.'
}), __metadata("design:type", Number)], EventbriteVenueSuggestionDto.prototype, "distanceMeters", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  enum: ['name', 'address'],
  description: "Why it's likely the Eventbrite venue: same name, or same street address. Null: just nearby."
}), __metadata("design:type", Object)], EventbriteVenueSuggestionDto.prototype, "match", void 0);
/** The Ivy venue an Eventbrite event's venue was found as or added as. */
class EventbriteVenueAddResultDto {}
exports.EventbriteVenueAddResultDto = EventbriteVenueAddResultDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], EventbriteVenueAddResultDto.prototype, "venuePublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], EventbriteVenueAddResultDto.prototype, "venueName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], EventbriteVenueAddResultDto.prototype, "address", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: ['existing', 'google', 'eventbrite'],
  description: 'existing: already on Ivy; google: added from Google Places; eventbrite: added from the Eventbrite venue details.'
}), __metadata("design:type", String)], EventbriteVenueAddResultDto.prototype, "source", void 0);
/** An upcoming event of an Eventbrite organization the server's API token belongs to. */
class EventbriteOrganizationEventDto {}
exports.EventbriteOrganizationEventDto = EventbriteOrganizationEventDto;
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Eventbrite event ID.'
}), __metadata("design:type", String)], EventbriteOrganizationEventDto.prototype, "eventbriteId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Public Eventbrite page of the event.'
}), __metadata("design:type", String)], EventbriteOrganizationEventDto.prototype, "url", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], EventbriteOrganizationEventDto.prototype, "name", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Start, ISO 8601 UTC.'
}), __metadata("design:type", Object)], EventbriteOrganizationEventDto.prototype, "eventStartDate", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: "IANA timezone of the event (e.g. America/Chicago), for showing its local time."
}), __metadata("design:type", Object)], EventbriteOrganizationEventDto.prototype, "timezone", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Eventbrite status: draft, live or started.'
}), __metadata("design:type", String)], EventbriteOrganizationEventDto.prototype, "status", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Listed publicly on Eventbrite (false for private / unlisted events).'
}), __metadata("design:type", Boolean)], EventbriteOrganizationEventDto.prototype, "listed", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Venue name on Eventbrite.'
}), __metadata("design:type", Object)], EventbriteOrganizationEventDto.prototype, "venueName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'One-line venue address on Eventbrite.'
}), __metadata("design:type", Object)], EventbriteOrganizationEventDto.prototype, "address", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], EventbriteOrganizationEventDto.prototype, "isOnline", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: [EventbriteVenueSuggestionDto],
  description: 'Ivy venues near the Eventbrite venue, best match first (same name, then nearest). Empty for online events or when nothing is close.'
}), __metadata("design:type", Array)], EventbriteOrganizationEventDto.prototype, "venueSuggestions", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Eventbrite organization the event belongs to.'
}), __metadata("design:type", String)], EventbriteOrganizationEventDto.prototype, "organizationName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: [EventbriteLinkedIvyEventDto],
  description: 'Ivy events already linked to this Eventbrite event.'
}), __metadata("design:type", Array)], EventbriteOrganizationEventDto.prototype, "linkedIvyEvents", void 0);
/** Outcome of importing one Eventbrite event into an Ivy venue. */
class EventbriteBulkImportResultDto {}
exports.EventbriteBulkImportResultDto = EventbriteBulkImportResultDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], EventbriteBulkImportResultDto.prototype, "eventbriteId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], EventbriteBulkImportResultDto.prototype, "venuePublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'created, skipped (already linked at that venue) or failed.'
}), __metadata("design:type", String)], EventbriteBulkImportResultDto.prototype, "status", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], EventbriteBulkImportResultDto.prototype, "specialPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Why it failed, readable by the admin.'
}), __metadata("design:type", Object)], EventbriteBulkImportResultDto.prototype, "error", void 0);
//# sourceMappingURL=EventbriteOrganizationEvent.dto.js.map